import { useQuery } from "@tanstack/react-query";

import { apiFetch, buildParams } from "@/lib/api";
import { StandardNodeOutput } from "@/types";

type Params = {
  account_id: string;
  role: string;
  project_id: string;
};

export function useStandardNodes(params: Params, enabled = true) {
  const query = buildParams(params);

  return useQuery({
    queryKey: ["standard-nodes", params],
    queryFn: () => apiFetch<StandardNodeOutput>(`/v1/standard-nodes${query}`),
    enabled,
  });
}
